/**
 * Children's Book Categories
 * 
 * Configuration for children's book categories used in filters and API requests
 * - be-label: Label used in the backend editor (ListInspectorControls)
 * - value: API value to send to the PRH API
 * - fe-label: Label displayed on the frontend (ChildrensCategoriesFilter)
 */

const childrensCategories = [
  {
    'be-label': '8x8',
    'value': 'EE',
    'fe-label': '8x8'
  },
  {
    'be-label': 'Board',
    'value': 'BRD',
    'fe-label': 'Board Books'
  },
  {
    'be-label': 'Book and Toy',
    'value': 'BAT',
    'fe-label': 'Book and Toy'
  },
  {
    'be-label': 'Chapter Book',
    'value': 'CB',
    'fe-label': 'Chapter Books'
  },
  {
    'be-label': 'Chapter Book/Early Reader',
    'value': 'CE',
    'fe-label': 'Early Reader Chapter Books'
  },
  {
    'be-label': 'Color and Activity',
    'value': 'CA',
    'fe-label': 'Coloring and Activities'
  },
  {
    'be-label': 'Early Readers',
    'value': 'ER',
    'fe-label': 'Early Readers'
  },
  {
    'be-label': 'Flash Cards',
    'value': 'FC',
    'fe-label': 'Flash Cards'
  },
  {
    'be-label': 'Graphic Novel',
    'value': 'GRA',
    'fe-label': 'Graphic Novels'
  },
  {
    'be-label': 'Graphic Novel/Chapter Book',
    'value': 'GNC',
    'fe-label': 'Chapter Book Graphic Novels'
  },
  {
    'be-label': 'Graphic Novel/Early Reader',
    'value': 'GNE',
    'fe-label': 'Early Reader Graphic Novels'
  },
  {
    'be-label': 'Graphic Novel/Middle Grade',
    'value': 'MGN',
    'fe-label': 'Middle Grade Graphic Novels'
  },
  {
    'be-label': 'Graphic Novel/Young Adult',
    'value': 'YGN',
    'fe-label': 'Young Adult Graphic Novels'
  },
  {
    'be-label': 'Hardcover Middle Grade',
    'value': 'HMG',
    'fe-label': 'Middle Grade Hardcovers'
  },
  {
    'be-label': 'Hardcover Picture Book',
    'value': 'HPB',
    'fe-label': 'Picture Book Hardcovers'
  },
  {
    'be-label': 'Hardcover Storybook Anthology',
    'value': 'HAS',
    'fe-label': 'Storybook Anthology Hardcovers'
  },
  {
    'be-label': 'Hardcover Young Adult',
    'value': 'HYA',
    'fe-label': 'Young Adult Hardcovers'
  },
  {
    'be-label': 'Novelty',
    'value': 'NOV',
    'fe-label': 'Novelty Books'
  },
  {
    'be-label': 'Paperback Middle Grade',
    'value': 'PMG',
    'fe-label': 'Middle Grade Paperbacks'
  },
  {
    'be-label': 'Paperback Picture Book',
    'value': 'PPB',
    'fe-label': 'Picture Book Paperbacks'
  },
  {
    'be-label': 'Paperback Storybook Anthology',
    'value': 'PSA',
    'fe-label': 'Storybook Anthology Paperbacks'
  },
  {
    'be-label': 'Paperback Young Adult',
    'value': 'PYA',
    'fe-label': 'Young Adult Paperbacks'
  },
  {
    'be-label': 'Test Prep',
    'value': 'TP',
    'fe-label': 'Test Prep'
  },
  {
    'be-label': 'Workbooks',
    'value': 'WBK',
    'fe-label': 'Workbooks'
  },
  {
    'be-label': 'Chapter Book Combined',
    'value': 'CB, GNC, CE',
    'fe-label': 'Chapter Books'
  },
  {
    'be-label': 'Early Readers Combined',
    'value': 'ER, GNE, CE',
    'fe-label': 'Early Readers'
  },
  {
    'be-label': 'Picture Book Combined',
    'value': 'HPB, PPB, EE',
    'fe-label': 'Picture Books'
  },
  {
    'be-label': 'Middle Grade Combined',
    'value': 'HMG, PMG, MGN',
    'fe-label': 'Middle Grade'
  },
  {
    'be-label': 'Young Adult Combined',
    'value': 'PYA, YGN, HYA',
    'fe-label': 'Young Adult'
  },
  {
    'be-label': 'Other',
    'value': 'PSA, NOV, HAS, BAT, FC',
    'fe-label': 'Other'
  },
  {
    'be-label': 'Graphic Novel Combined',
    'value': 'GNC, GNE, MGN, YGN, GRA',
    'fe-label': 'Graphic Novels'
  }
];

export default childrensCategories;
